import React from 'react';
import './TeamSection.css';
import tsimg1 from '../../assets/Priyanshu jain.jpeg';
// import tsimg2 from '../../assets/tsimg2.jpg';
// import tsimg3 from '../../assets/tsimg3.jpg';
import tsimg4 from '../../assets/Nikhil.jpeg';

const teamMembers = [
  {
    name: "Priyanshu Jain",
    role: "Founder, PSJ Capital Ventures",
  
    qualification: "IIM Lucknow | CBS (BFIA) | CFA Level II | FRM Level I | CMT Level I",
    image: tsimg1,
  },
  // {
  //   name: "Devesh Dabriwal",
  //   role: "Research Lead at PSJ Capital.",
   
  //   qualification: "IIM Lucknow MBA | CFA (Level 2)",
  //   image: tsimg2,
  // },
  // {
  //   name: "Riya Khanna",
  //   role: "Associate Business Development & Client Relations",
   
  //   qualification: "Finance graduate from University of Delhi and Cleared CFA L1",
  //   image: tsimg3,
  // },
  {
    name: "Nikhil",
    role: "Private Wealth Manager",
    qualification: "BBA FINANCE | CFA LEVEL 2 CLEARED",
    image: tsimg4,
  },
];

const TeamSection = () => {
  return (
    <div className="team-section">
      {/* <h3 className="team-subtitle">Meet Team Member</h3> */}
      <h1 className="team-title">Meet Our Team</h1>
      <div className="team-container">
        {teamMembers.map((member, index) => (
          <div className="team-card" key={index}>
            <img src={member.image} alt={member.name} />
            <div className="team-info">
              <p>{member.role}</p>
              <h4>{member.name}</h4>
              {/* <p>{member.phone}</p> */}
              <p>{member.qualification}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamSection;
